// Type imports:
import {
    LoginActions,
    LOG_OUT,
    SET_USERNAME_AND_PASSWORD,
    SYSTEM_PROFILE_FAILOVER,
    REQUEST_USER_INFO_SUCCESS,
    REQUEST_USER_INFO_FAILURE,
    REQUEST_LOGIN_SUCCESS,
    REQUEST_FORBIDDEN,
    REQUEST_LOGIN_FAILURE
} from '../../types/redux/LoginTypes';
import { decodeAccessToken } from '../../services/helperFunction';

const ORGANIZTION_TO_GROUP_ID_MAP: {
    [organization: string]: string | undefined
} = {
    'Kóði ehf': 'Y48',
    'Kóði Staff': 'Y48',
    'Íslandsbanki': 'ISB',
    'Kvika': 'KVB',
    // 'Íslenskir fjárfestar hf.': 'IFJ',
    'Íslenskir fjárfestar hf.': 'ACR',
    'Arion Banki hf.': 'ARB',
    'Arctica Finance': 'ARF',
    'Landsbankinn': 'LAI',
    'Íslensk Verðbréf': 'IVE',
    'Fossar markaðir hf': 'FOS',
}

export interface ILoginState {
    //
    username: string,
    password: string,
    //
    accessTokenV2: string,
    loginErrorMessage: string | null
    //
    groupId: string | null,
    loginUserName: string,
    //
    startLogoutTimer: boolean,
    // 
    isLoggedIn: boolean,
    hasPrivateData: boolean,
    isSessionExpired: boolean
}

const getInitialState = (): ILoginState => ({
    //
    username: '',
    password: '',
    //
    accessTokenV2: '',
    loginErrorMessage: null,
    //
    groupId: null,
    loginUserName: '',
    //
    startLogoutTimer: false,
    //
    isLoggedIn: false,
    hasPrivateData: false,
    isSessionExpired: false // Always false on initial load
});

const initialState = getInitialState();

const LOCAL_STORAGE_SIGTI_ACCESS_TOKEN = 'httyd-3';
// Bara að taka smá til...
try {
    localStorage.removeItem('SIGTI_Username');
    localStorage.removeItem('SIGTI_Password');
    // So that users that loged in with old version can delete info from localstorage.
    localStorage.removeItem('SIGTI_AccessToken');
    localStorage.removeItem('SIGTI_AccessTokenExpiresAt');
    localStorage.removeItem('SIGTI_EmsToken');
    localStorage.removeItem('SIGTI_EmsTokenExpiresAt');
} catch (e) {}


// Change initialState if Local Storage shows that user is logged in. (login)
try {
    const localStorageSigtiAccessToken = localStorage.getItem(LOCAL_STORAGE_SIGTI_ACCESS_TOKEN);

    // Necessary to be logged in with sigti token.
    if (localStorageSigtiAccessToken === null) throw new Error();

    // Decode Access Token and check if it has access to private data.
    if (decodeAccessToken(localStorageSigtiAccessToken) === true) {
        initialState['accessTokenV2'] = localStorageSigtiAccessToken ;

        initialState['isLoggedIn'] = true;
        initialState['hasPrivateData'] = true;
        initialState['isSessionExpired'] = false;
    } else if (decodeAccessToken(localStorageSigtiAccessToken) === false) {

        initialState['accessTokenV2'] = localStorageSigtiAccessToken;

        initialState['isLoggedIn'] = true;
        initialState['hasPrivateData'] = false;
        initialState['isSessionExpired'] = false;
    } else {
        throw new Error("Token invalid.");
    }
} catch (e) {
    // Local Storage can throw errors due to user privacy settings.
    // Could also be from token decoding.
    try {
        localStorage.removeItem(LOCAL_STORAGE_SIGTI_ACCESS_TOKEN);
    } catch (e) {};
}


export default function(state: ILoginState = initialState, action: LoginActions): ILoginState {
    switch (action.type) {
        // SET USERNAME AND PASSWORD
        case SET_USERNAME_AND_PASSWORD: {
            const { username, password } = action.payload;
            const newState: ILoginState = {
                ...state,
                username,
                password
            };
            return newState;
        }
        // ===================================== REQUEST LOGIN SUCCESS =====================================
        case REQUEST_LOGIN_SUCCESS: {
            const { token } = action.payload;
            // Decode token to check for private data access
            const hasPrivateData = decodeAccessToken(token) === true;

            const newState: ILoginState = {
                ...state,
                accessTokenV2: token,
                isLoggedIn: true,
                isSessionExpired: false,
                hasPrivateData
            };
            // Set token and expirationTime to local storage.
            try {
                localStorage.setItem(LOCAL_STORAGE_SIGTI_ACCESS_TOKEN, token)
            } catch (e) {
                // Local Storage can throw errors due to user privacy settings.
            }

            return newState;
        }
        // ===================================== REQUEST LOGIN FAILURE =====================================
        case REQUEST_LOGIN_FAILURE: {
            const { code } = action.payload;
            var errorMessage = ""
            if (code === 500) {
                errorMessage = "Error Logging In"
            } else {
                errorMessage = "Invalid password or email"
            }

            const newState: ILoginState = {
                ...state,
                loginErrorMessage: errorMessage
            };
            return newState;
        }
        // ===================================== REQUEST LOGOUT OF SIGTI (LOG OUT) =====================================
        case LOG_OUT: {
            try {
                localStorage.removeItem(LOCAL_STORAGE_SIGTI_ACCESS_TOKEN);
            } catch (e) {
                // Local Storage can throw errors due to user privacy settings.
            }
            
            return getInitialState();
        }
        // ===================================== SESSION HAS EXPIRED =====================================
        case REQUEST_FORBIDDEN: {
            try {
                localStorage.removeItem(LOCAL_STORAGE_SIGTI_ACCESS_TOKEN);
            } catch (e) {
                // Local Storage can throw errors due to user privacy settings.
            }
            
            return getInitialState();
        }
        // USER INFO
        case REQUEST_USER_INFO_SUCCESS: {
            const { userName, organization } = action.payload;
            const groupId = ORGANIZTION_TO_GROUP_ID_MAP[organization] ?? null;

            const newState: ILoginState = {
                ...state,
                loginUserName: userName,
                groupId: groupId
            };

            return newState;
        }
        case REQUEST_USER_INFO_FAILURE: {
            const newState: ILoginState = {
                ...state,
                loginUserName: "Error Fetching User Info",
                groupId: "",
            };
            return newState;
        }
        // SYSTEM PROFILE FAILOVER
        case SYSTEM_PROFILE_FAILOVER: {
            const newState: ILoginState = {
                ...state,
            };
            return newState;
        }
        default:
            return state;
    }
}